const agent = [
    {
        path: "agent",
        name: "agent",
        component: () => import("@/views/agent/AgentIndex.vue"),
        meta: {
            title: "Agent",
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
];

export default agent;
